import { FC, useState } from "react"
import classes from "./styles.module.scss"
import { Outlet } from "react-router-dom"
import { Header } from "@/widgets/Header"

import { useAppSelector, useAppDispatch } from "@/shared/lib/store"
import { useEffect } from "react"
import { fetchOptions } from "@/entities/options"

import { Footer } from "@/widgets/Footer"
import { Stack } from "@mantine/core"
import { Sidebar } from "@/shared/ui/Sidebar"
import { Filter, FilterSkeleton, selectFilterInputs, selectFilterLoading } from "@/features/Filter"
import { useMediaQuery } from "@mantine/hooks"

interface LayoutProps {}

export const Layout: FC<LayoutProps> = ({}) => {
	const inputs = useAppSelector(selectFilterInputs)
	const loading = useAppSelector(selectFilterLoading)
	const [isSidebarOpen, setIsSidebarOpen] = useState(false)
	const isMobile = useMediaQuery("(max-width: 768px)")

	const dispatch = useAppDispatch()

	useEffect(() => {
		dispatch(fetchOptions())
	}, [dispatch])

	return (
		<Stack gap={56} className={classes.layout}>
			<Header openSidebar={() => setIsSidebarOpen(!isSidebarOpen)} isOpen={isSidebarOpen} />
			{isMobile && (
				<Sidebar
					isOpen={isSidebarOpen}
					onClose={() => setIsSidebarOpen(false)}
					top={92}
					py={16}
					animate="fade-up"
				>
					{!loading && (
						<Filter onSubmitButtonClick={() => setIsSidebarOpen(false)} filterInputs={inputs} />
					)}
					{loading && <FilterSkeleton />}
				</Sidebar>
			)}
			<main>
				<Outlet />
			</main>
			<Footer />
		</Stack>
	)
}
